import type { IEpisodeCategory, IService, IServiceGroupWithProfileSettings } from './';

export enum ServiceRightType {
    serviceConsumer = 'serviceConsumer',
    serviceEmployment = 'serviceEmployment',
    serviceProvider = 'serviceProvider',
    serviceSupervisor = 'serviceSupervisor',
}

export enum EpisodeCategoryRightType {
    serviceReader = 'serviceReader',
}

export interface IServiceRight {
    endDate?: string | Date | null;
    id: string;
    isAnalyst?: boolean;
    isBiometrician?: boolean;
    isGrader?: boolean;
    isRequestCreator?: boolean;
    rightType: ServiceRightType;
    service: Pick<IService, 'id' | 'name' | 'code' | 'serviceType'>;
    serviceGroup: Pick<IServiceGroupWithProfileSettings, 'name'>;
    startDate: string | Date;
}

export interface IEpisodeCategoryRight {
    endDate?: string | Date | null;
    episodeCategory: Pick<IEpisodeCategory, 'name'>;
    id: string;
    rightType: EpisodeCategoryRightType;
    startDate: string | Date;
}

export type IRight = IServiceRight | IEpisodeCategoryRight;

export function isServiceRight(right: any): right is IServiceRight {
    return 'service' in right;
}

export function isEpisodeCategoryRight(right: any): right is IEpisodeCategoryRight {
    return right.rightType === EpisodeCategoryRightType.serviceReader && 'episodeCategory' in right;
}
